var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-input"},[_c('ColorPicker',{ref:"colorPicker",attrs:{"value":_vm.value},on:{"input":_vm.handleInput}}),_c('span',{staticClass:"is-flex-grow-1",on:{"click":_vm.handleTextInputClick}},[_c('TextInput',{attrs:{"value":_vm.value,"disabled":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }